import Header from '../components/Header';
import Footer from '../components/Footer';
import TestimonialSection from '../components/TestimonialSection';

const HearFromOurPeople = () => {
  const testimonials = [
    {
      name: 'Amina Hassan',
      role: 'Care Experience Lead',
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80',
      testimonial: "I joined over a year and a half ago, and in that time I've experienced multiple opportunities to develop myself and those around me through a multitude of avenues. Whether it be through 1:1 supervision, bespoke face to face training, or management development forums allowing me to discuss and share information about my experiences, I've been able to grow as a manager in a safe, nurturing and development focused environment. This has led me to becoming the Registered Manager of a solo home, an exciting new direction for the company to take that allows us to offer a more focused care package for a wider group of young people that needed bespoke therapeutic support. The team we have built is child centred and we all ensure that everything we do has the young people in mind.",
      isAlt: false
    },
    {
      name: 'Priya Nair',
      role: 'Residential Care Worker',
      image: 'https://images.unsplash.com/photo-1525134479668-1bee5c7c6845?w=400&q=80',
      testimonial: "I joined in October 2021 having come from a retail background and no experience of working with children in care. I was really happy when I got the chance to start my dream job, looking after young people who are in need of support and guidance. No two days are the same, which is what I like as it is never boring. I mostly enjoy spending time with the young people I look after, they're all fantastic and I get to experience many different things whilst with them. I hope to have a lasting positive effect on them and be able to make a difference in their lives every day. I wouldn't wish to be doing anything else and I'm hoping this is the start of my lifelong career after I have complete my level 4 qualification which is fully funded. Working here isn't like having a job, it's more like having an extra family.",
      isAlt: true
    },
    {
      name: 'Luca Moretti',
      role: 'Learning & Development Partner',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80',
      testimonial: "I'd say the Recruitment process was very friendly and extremely supportive the team always had time to speak to me and offer support and advice throughout the process, the interview was thorough, but I was made to feel very relaxed. On starting in my position, I was given a really good induction and made to feel welcome and part of a team from minute one!",
      isAlt: false
    },
    {
      name: 'Sofia Alvarez',
      role: 'Talent Lead',
      image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&q=80',
      testimonial: "The world of recruitment is about doing all you can to promote the company values and what we offer to the candidate. This is where Testa Care makes my life easy! It's refreshing to work with amazing home managers who really do have the young people at the heart of all that they do, so to become a part of any of our homes is something I can talk passionately about potential candidates. My own career path has completely changed due to Testa Care, and they have given me the support and guidance to enrol on a course that will further help develop my career. The family feel really does cascade through the whole company - conversations with colleagues, making connections with likeminded business professionals to bounce ideas around and sharing thoughts with the CEO, all feel completely natural and are welcomed. My background was retail and sales, and at the age of 35 I thought it too late to find a role I'd enjoy as much and that I could use my skills in, then along came Testa Care!",
      isAlt: true
    }
  ];

  return (
    <div className="HearFromOurPeople">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        {/* Hero Section */}
        <div
        className="relative bg-cover bg-center"
        style={{
          backgroundImage: "url('/assets/images/tc-nurse-smile.jpeg')",
          height: 'calc(66vh - 90px)',
          minHeight: '400px',
        }}
      >
        <div className="absolute inset-0 flex items-end justify-center pb-0">
          <div className="w-full bg-white bg-opacity-90 py-8 px-8">
            <div className="max-w-6xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-light mb-0" style={{ color: '#000' }}>
                Hear From Our People
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      {testimonials.map((testimonial, index) => (
        <TestimonialSection
          key={index}
          name={testimonial.name}
          role={testimonial.role}
          image={testimonial.image}
          testimonial={testimonial.testimonial}
          isAlt={testimonial.isAlt}
        />
      ))}

        <Footer />
      </div>
    </div>
  );
};

export default HearFromOurPeople;




